// Navigation.js
// Legacy wrapper to ensure every page uses the unified navbar header.
import React from 'react';
import WithSubnavigation from '../Pages/navbar';

const noop = () => {};

const Navigation = ({
  pagetitle, // kept for compatibility; navbar does not display it directly
  username = '',
  openChangePasswordModal = noop,
  onLogout = noop,
  notifications = [],
  onToggleSidebar = noop,
  collapsed = false,
  chatLink = null,
}) => {
  return (
    <WithSubnavigation
      username={username}
      openChangePasswordModal={openChangePasswordModal}
      onLogout={onLogout}
      notifications={notifications}
      onToggleSidebar={onToggleSidebar}
      collapsed={collapsed}
      chatLink={chatLink}
    />
  );
};

export default Navigation;
